import { gql } from '@apollo/client'

export const CreatePPLFamilyFromListingMutation = gql`
    mutation createPPLFamilyFromListing(
        $input: CreatePPLFamilyFromListingInput!
    ) {
        createPPLFamilyFromListing(input: $input) {
            listingId
        }
    }
`
